import axios from "axios";
import { authFormPost, authPost } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/w188_api";

export function walletUICall(queryParams) {
  return authPost(`${baseUrl}/Member2.ashx`, queryParams);
}

export const atmDepositRequest = (queryParams) => {
  return authFormPost(
    `${window.location.protocol}//media.lotto4896.com/api/deposit.php`,
    queryParams
  );
};
export function walletUICall2(queryParams) {
  return authPost(`${baseUrl}/Member3.ashx`, queryParams);
}
export function transferTo(queryParams) {
  return authPost(`${baseUrl}/Member6.ashx`, queryParams);
}
